module.exports = __webpack_public_path__ + "0.d64fd894d6d7775b4d33.worker.js"